/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/spy_def_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M22.457 15.812c-.005-.011-.004-.024-.01-.035C22.359 15.602 20.26 11.5 16 11.5s-6.36 4.102-6.447 4.276c-.006.011-.005.024-.01.035a.4.4 0 00-.025.096c-.006.032-.013.062-.013.093s.007.061.013.092a.521.521 0 00.025.096c.005.011.004.024.01.035C9.64 16.398 11.74 20.5 16 20.5s6.359-4.102 6.447-4.276c.006-.011.005-.024.01-.035a.358.358 0 00.025-.096c.006-.031.013-.061.013-.092s-.007-.061-.013-.092a.355.355 0 00-.025-.097zM16 19.5c-3.115 0-4.951-2.703-5.426-3.5.475-.797 2.311-3.5 5.426-3.5s4.951 2.703 5.426 3.5c-.475.797-2.311 3.5-5.426 3.5z"/><circle pid="1" cx="16" cy="16" r="1"/><path pid="2" d="M28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646L31.354 16 28 12.646zM26 26H6V6h20v20z"/>'
  }
})
